import {
  ADD_ALERT,
  ADD_ALERT_USER,
  ADD_NON_WORKING_SLOT,
  ADD_NON_WORKING_SLOT_VALIDITY,
  ADD_NON_WORKING_SLOT_VEHICLE,
  GET_ACCOUNTS_DROPDOWN,
  GET_ALERTS,
  GET_ALERT_RULES_DROPDOWN,
  GET_ALERT_USERS,
  GET_INSTALLED_VEHICLE_BY_STATE,
  GET_MANUFACTURER_DROPDOWN,
  GET_NON_WORKING_SLOTS,
  GET_NON_WORKING_SLOTS_VALIDITY,
  GET_NON_WORKING_SLOTS_VEHICLE,
  GET_RFC_DROPDOWN,
  GET_USER_DROPDOWN,
  UPDATE_ALERT,
  GET_ALERT_NOTIFICATION_TYPE_DROPDOWN,
  UPDATE_ALERT_STATUS,
  UPDATE_ALERT_USER_STATUS,
  UPDATE_NON_WORKING_SLOT_STATUS,
  UPDATE_NON_WORKING_SLOT_VALIDITY_STATUS,
  UPDATE_NON_WORKING_SLOT_VEHICLE_STATUS,
} from "../actions/alertType";

const initialState = {
  getVehicles: [],
  getAlerts: [],
  updateAlertStatus: [],
  addAlertData: [],
  updateAlertData: [],
  getAlertRulesDropdown: [],
  getAlertUsers: [],
  getAlertUserStatus: [],
  getAccountDropdown: [],
  getManufaturerDropdown: [],
  getRfcDropdown: [],
  getUserDropdown: [],
  addALertUser: [],
  getNonWorkingSlots: [],
  updateNonWorkingSlotStatus: [],
  addNonWorkingSlotData: [],
  getNonWorkingSlotsVehicle: [],
  updateNonWorkingSlotVehicleStatus: [],
  addNonWorkingSlotVehicleData: [],
};
const getInstalledVehicleByStateReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_INSTALLED_VEHICLE_BY_STATE:
      return {
        ...state,
        getVehicles: payload,
      };
    default:
      return state;
  }
};
const getAlertsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_ALERTS:
      return {
        ...state,
        getAlerts: payload,
      };
    case UPDATE_ALERT_STATUS:
      return {
        ...state,
        updateAlertStatus: payload,
      };
    case ADD_ALERT:
      return {
        ...state,
        addAlertData: payload,
      };
    case UPDATE_ALERT:
      return {
        ...state,
        updateAlertData: payload,
      };
    case GET_ALERT_RULES_DROPDOWN:
      return {
        ...state,
        getAlertRulesDropdown: payload,
      };
    case GET_ALERT_USERS:
      return {
        ...state,
        getAlertUsers: payload,
      };
    case UPDATE_ALERT_USER_STATUS:
      return {
        ...state,
        getAlertUserStatus: payload,
      };
    case GET_ACCOUNTS_DROPDOWN:
      return {
        ...state,
        getAccountDropdown: payload,
      };
    case GET_MANUFACTURER_DROPDOWN:
      return {
        ...state,
        getManufaturerDropdown: payload,
      };
    case GET_RFC_DROPDOWN:
      return {
        ...state,
        getRfcDropdown: payload,
      };
    case GET_USER_DROPDOWN:
      return {
        ...state,
        getUserDropdown: payload,
      };
    case GET_ALERT_NOTIFICATION_TYPE_DROPDOWN:
      return {
        ...state,
        alertNotificationType: payload,
      };

    case ADD_ALERT_USER:
      return {
        ...state,
        addALertUser: payload,
      };
    default:
      return state;
  }
};
const getNonWorkingSlotsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_NON_WORKING_SLOTS:
      return {
        ...state,
        getNonWorkingSlots: payload,
      };
    case UPDATE_NON_WORKING_SLOT_STATUS:
      return {
        ...state,
        updateNonWorkingSlotStatus: payload,
      };
    case ADD_NON_WORKING_SLOT:
      return {
        ...state,
        addNonWorkingSlotData: payload,
      };
    case GET_NON_WORKING_SLOTS_VALIDITY:
      return {
        ...state,
        getNonWorkingSlotsValidity: payload,
      };
    case UPDATE_NON_WORKING_SLOT_VALIDITY_STATUS:
      return {
        ...state,
        updateNonWorkingSlotValidityStatus: payload,
      };
    case ADD_NON_WORKING_SLOT_VALIDITY:
      return {
        ...state,
        addNonWorkingSlotValidityData: payload,
      };
    case GET_NON_WORKING_SLOTS_VEHICLE:
      return {
        ...state,
        getNonWorkingSlotsVehicle: payload,
      };
    case UPDATE_NON_WORKING_SLOT_VEHICLE_STATUS:
      return {
        ...state,
        updateNonWorkingSlotVehicleStatus: payload,
      };
    case ADD_NON_WORKING_SLOT_VEHICLE:
      return {
        ...state,
        addNonWorkingSlotVehicleData: payload,
      };
    default:
      return state;
  }
};

export {
  getInstalledVehicleByStateReducer,
  getAlertsReducer,
  getNonWorkingSlotsReducer,
};
